<template>
  <div class="dashboard">
    <h2>产品组设置</h2>

    <!-- 功能区 -->
    <el-row class="toolbar" :gutter="20">
      <el-col :span="18">
        <el-button-group>
          <el-button 
            type="info" 
            icon="el-icon-refresh" 
            @click="handleRefresh"
          >刷新</el-button>
          <el-button 
            type="primary" 
            @click="showAddDialog"
          >新增产品组</el-button>
          <el-button 
            type="danger" 
            @click="handleBatchDelete"
          >批量删除</el-button>
        </el-button-group>
      </el-col>
      <!-- 搜索栏保持不变 -->
    </el-row>

    
    <!-- 数据表格 -->
    <el-table
        :data="filteredProducts"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        v-loading="loading"
        border
      >
        <el-table-column :resizable="false" type="selection" width="55" />
        <el-table-column :resizable="false" prop="name" label="产品组" width="180" />
        <el-table-column :resizable="false" label="描述">
          <template #default="{ row }">
            {{ row.configs.desc || '-- 无描述 --' }}
          </template>
        </el-table-column>

        <el-table-column :resizable="false" prop="name" label="默认产品" width="180" >
          <template #default="{ row }">
              {{ row.configs.default || '无' }}
          </template>
        </el-table-column>

        <!-- 在默认产品列上方添加状态列 -->
        <el-table-column :resizable="false" label="状态" width="120">
          <template #default="{ row }">
            <el-tag :type="row.isvaild ? 'success' : 'danger'" effect="dark">
              {{ row.isvaild ? '可用' : '异常' }}
            </el-tag>
          </template>
        </el-table-column>

         <el-table-column :resizable="false" prop="productnum" label="产品数量" width="120" />
        
        <!-- 规则列 -->
        <el-table-column :resizable="false" label="渠道映射" width="400">
          <template #default="{ row }">
            <div class="rule-config-cell">
              <el-tooltip 
                effect="dark" 
                placement="top"
                :disabled="!row.configs.src2tar || Object.keys(row.configs.src2tar).length === 0"
              >
                <template #content>
                  <div class="full-rule-content">
                    <div 
                      v-for="(value, key) in row.configs.src2tar" 
                      :key="key"
                      class="rule-tag"
                    >{{ key }} → {{ value }}</div>
                    <span v-if="!Object.keys(row.configs.src2tar).length">无渠道配置</span>
                  </div>
                </template>
                
                <div class="rule-tags-container">
                  <template v-if="Object.keys(row.configs.src2tar).length">
                    <div 
                      v-for="(value, key) in row.configs.src2tar" 
                      :key="key"
                      class="rule-tag"
                    >{{ key }} → {{ value }}</div>
                  </template>
                  <span v-else class="empty-rule">-- 无 --</span>
                </div>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>

        <!-- 新增产品详情列 -->
        <el-table-column :resizable="false" label="产品详情">
          <template #default="{ row }">
            <el-button 
              type="text" 
              @click="handleViewDetails(row)"
            >查看详情</el-button>
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column :resizable="false" label="操作" width="280">
         <template #default="{ $index, row }">
            <el-button 
              size="mini" 
              type="primary" 
              @click="handleCopyLink(row)"
              style="margin-right: 8px"
            >复制链接</el-button>
            <el-button 
              size="mini" 
              type="primary" 
              @click="showViewDialog(row)"
              style="margin-right: 8px"
            >编辑</el-button>
            <el-button 
              size="mini" 
              type="danger" 
              @click="handleDelete(row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="formData" label-width="160px">
        <el-form-item label="产品组名称(不能中文)" required>
          <el-input 
            v-no-space
            v-model="formData.name" 
            :disabled="dialogType !== 'add'" 
            @input="handleNameInput"
          ></el-input>
        </el-form-item>

        <el-form-item label="产品组描述">
          <el-input
            v-model="formData.configs.desc"
            type="textarea"
            :rows="2"
            placeholder="请输入产品组描述"
          ></el-input>
        </el-form-item>

        <el-form-item label="默认产品(不能中文)">
          <el-input 
            v-no-space
            v-model="formData.configs.default" 
            placeholder="请输入默认产品"
            @input="handleDefaultInput"
          ></el-input>
        </el-form-item>

        <el-form-item label="渠道映射">
          <div  class="kv-editor">
            <div v-for="(item, index) in src2tarList" :key="index" class="kv-row">
              <el-input v-no-space v-model="item.key" placeholder="渠道" style="width: 200px"></el-input>
              <span class="separator">→</span>
              <el-input v-no-space v-model="item.value" placeholder="产品" style="width: 200px"></el-input>
              <el-button
                type="danger" 
                icon="el-icon-delete"
                circle
                @click="removeKv(index)"
              ></el-button>
            </div>
            <el-button type="primary" plain @click="addKv">+ 添加映射</el-button>
          </div>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <template>
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </template>
      </div>
    </el-dialog>
    <el-dialog
      :title="selectedGroup + '产品详情'"
      :visible.sync="productDialogVisible"
      :close-on-click-modal="false"
      width="90%"
      top="5vh"
      custom-class="product-detail-dialog"
    >
      <product-component 
        :external-group="selectedGroup"
        v-if="productDialogVisible"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="hanldeCloseDetails">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {GroupList, AddGroup, UpdateGroup, DelGroup, GetProductTips} from '../api/index'

import ProductComponent from '../components/ProductComponent.vue'

export default {
  name: 'Products',
  components: {
    ProductComponent
  },
  data() {
    return {
      searchKey: '',
      products: [],
      version:'',
      multipleSelection: [],
      dialogVisible: false,
      isEditMode: false,
      dialogType: 'add', // add/view
      formData: {
        name: '',
        configs: {
          default: '',
          src2tar: {}
        }
      },
      src2tarList: [],
      loading:false,
      productDialogVisible: false,
      selectedGroup: '',
    }
  },
  computed: {
    filteredProducts() {
      return this.products.filter(item => 
        item.name.toLowerCase().includes(this.searchKey.toLowerCase()))
    },
    dialogTitle() {
      return this.dialogType === 'add' ? '新增产品组' : '编辑产品组'
    }
  },
  created(){
    this.getList()
  },
  methods: {

    // 新增刷新方法
    handleRefresh() {
      this.getList()
      this.$message.success("已刷新")
    },

    getList(){
      this.loading = true
      GroupList().then(res => {
        this.products = res.data
        this.loading = false
        this.version = res.version
      }).catch(error => {
        this.loading = false
        this.$message.error('获取数据失败:'+error)
      })
    },

    handleViewDetails(row) {
      this.selectedGroup = row.name
      this.productDialogVisible = true
    },

    hanldeCloseDetails(){
      this.productDialogVisible = false
      this.getList()
    },

    // 显示新增对话框
    showAddDialog() {
      this.dialogType = 'add'
      this.isEditMode = true
      this.resetForm()
      this.dialogVisible = true
    },
    // 显示查看对话框
    showViewDialog(row) {
      this.dialogType = 'view'
      this.isEditMode = false
      this.formData = JSON.parse(JSON.stringify(row))
      this.src2tarList = Object.entries(row.configs.src2tar).map(([key, value]) => ({
        key,
        value
      }))
      this.dialogVisible = true
    },

    // 进入编辑模式
    enterEditMode() {
      this.isEditMode = true
      this.src2tarList = Object.entries(this.formData.configs.src2tar).map(([key, value]) => ({
        key,
        value
      }))
    },

    // 添加键值对
    addKv() {
      this.src2tarList.push({ key: '', value: '' })
    },

    // 删除键值对
    removeKv(index) {
      this.src2tarList.splice(index, 1)
    },

     // 提交表单
    submitForm() {
      // 转换src2tar格式
      const src2tar = this.src2tarList.reduce((acc, cur) => {
        if (cur.key && cur.value) {
          acc[cur.key] = cur.value
        }
        return acc
      }, {})

      const newData = {
        ...this.formData,
        configs: {
          ...this.formData.configs,
          src2tar: src2tar,
          desc: this.formData.configs.desc || '' // 确保desc字段存在
        }
      }

      if (this.dialogType === 'add') {

        AddGroup(newData).then(() => {
          this.getList()
          this.$message.success("添加成功")
        }).catch(() => {
          this.$message.error('添加失败')
        })

      } else {
        console.log("版本",this.version)
        UpdateGroup(this.formData.name, {...newData.configs,version:this.version}).then(() => {
          this.getList()
          this.$message.success("保存成功")
        }).catch(() => {
          this.$message.error('保存失败')
        })
      }

      this.dialogVisible = false
    },

    // 重置表单
    resetForm() {
      this.formData = {
        name: '',
        configs: {
          default: '',
          src2tar: {},
          desc:'',
        }
      }
      this.src2tarList = []
    },

    handleSearch() {
      // 搜索逻辑已通过计算属性自动处理
    },

    handleDelete(row) {
      this.$confirm('确定要删除该产品组吗？', '警告', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        DelGroup({names:[row.name], version:this.version}).then(() => {
          this.getList()
          this.$message.success("删除成功")
        }).catch(() => {
          this.$message.error('删除失败')
        })
      }).catch(() => {})
    },

    handleBatchDelete() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('请先选择要删除的项目')
        return
      }

      this.$confirm(`确定要删除选中的 ${this.multipleSelection.length} 个项目吗？`, '批量删除', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        var dels = []
        this.multipleSelection.forEach(item => {
          dels.push(item.name)
        })
        DelGroup(dels).then(() => {
          this.getList()
          this.$message.success("删除成功")
        }).catch(error => {
          this.$message.error('删除失败:'+error)
        })
      }).catch(() => {})
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleCopyLink(row) {
      if(!row.configs.default){
        this.$message.error("默认产品为空")
        return
      }

      GetProductTips(row.configs.default).then(res=>{
            var tipstr = ""
            for(var k in res.data){
            var title = k + "链接:"
            if(k == "comm")
            {
                title = "通用链接:"
            }
            if(tipstr == "")
            {
                tipstr =title +"\n"+ "http://ocpx.sfkjad.com/comm/?group="+row.name +"&" + res.data[k] 
            }else{
                tipstr = tipstr + "\n\n" + title +"\n" + "http://ocpx.sfkjad.com/comm/?group=" + row.name +"&" + res.data[k] 
            }
            }
            navigator.clipboard.writeText(tipstr).then(() => {
              this.$message.success('已复制到剪贴板')
            }).catch(err => {
              console.error('复制失败:', err)
              this.$message.error('复制失败，请手动选择内容复制')
            })
      }).catch(err=>{
        this.$message.error("获取链接失败:"+err)
      })
    },
    // 处理产品组名称输入
    handleNameInput(value) {
      this.formData.name = value.replace(/[^\w]/g, '');
    },

    // 处理默认产品输入
    handleDefaultInput(value) {
      this.formData.configs.default = value.replace(/[^\w]/g, '');
    },
    formatSrc2tar(src2tar) {
      if (!src2tar || Object.keys(src2tar).length === 0) return ''
      return Object.entries(src2tar)
        .map(([k, v]) => `${k}→${v}`)
        .join(', ')
    },
  }
}
</script>

<style scoped>

/* 新增描述列样式 */
.el-table .cell {
  white-space: pre-line;
  line-height: 1.5;
}

.dashboard {
  padding: 20px;
}
.toolbar {
  margin-bottom: 20px;
}
.el-input-group {
  width: 100%;
}

.kv-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.separator {
  margin: 0 10px;
  color: #909399;
}

.readonly-kv .kv-item {
  padding: 5px 0;
  border-bottom: 1px solid #ebeef5;
}

.kv-key {
  color: #409EFF;
  margin-right: 8px;
}

.kv-value {
  color: #67C23A;
}

.el-dialog__body {
  padding: 20px 30px;
}

.el-form-item {
  margin-bottom: 22px;
}

/* 添加按钮间距 */
.rule-config-cell {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.rule-tags-container {
  flex: 1;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  min-height: 24px; /* 单行高度 */
  max-height: 72px; /* 3行高度 */
}

.rule-tag {
  display: inline-block;
  background: #f0f2f5;
  border-radius: 4px;
  padding: 2px 8px;
  margin: 2px 4px 2px 0;
  font-size: 12px;
  color: #606266;
  border: 1px solid #e4e7ed;
  white-space: nowrap;
}

.full-rule-content .rule-tag {
  margin-bottom: 4px;
}

.empty-rule {
  color: #909399;
  font-style: italic;
}

.view-rule-btn {
  flex-shrink: 0;
  align-self: center;
}

/* Tooltip样式优化 */
.el-tooltip__popper {
  max-width: 400px;
  max-height: 300px;
  overflow-y: auto;
  
}

</style>